/* eslint-disable react/prop-types */
import { keyframes, LinearProgress, Stack } from "@mui/material";

export default function TimedProgressBar({ progress }) {
  //const [isFull, setIsFull] = useState(false);

  const stripes = keyframes`from {
      background-position: 0 0;
    }
    to {
      background-position: 100% 0%;
    }`;

  // useEffect(() => {
  //   if (progress >= 100 && !isFull) setIsFull(true);
  // }, [progress]);

  return (
    <Stack
      sx={{ padding: "3px", borderRadius: "5px", border: "solid thin #938F8F" }}
    >
      <LinearProgress
        color="secondary"
        variant="determinate" //{isFull ? "indeterminate" : "determinate"}
        value={progress}
        style={{
          height: "20px",
          borderRadius: "3px",
          bar: { color: "green" },
        }}
        sx={{
          "& .MuiLinearProgress-bar": {
            backgroundImage: `repeating-linear-gradient(90deg, #FF5F00, #FF5F00 12.5%, #ff9454 25%, #FF5F00 37.5%, #FF5F00 50%)`,
            backgroundSize: `200% 200%`,
            animation: `${stripes} 3s linear reverse infinite`,
          },
        }}
      />
    </Stack>
  );
}
